import { Component } from '@angular/core';
import { RokezzzNotificationService } from '../../../notification/services/notification.service';
import { Notification } from '../../api/notification';

@Component({
    selector: '.rokezzz-notification',
    standalone: true,
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})

export class RokezzzNotificationComponent {
    public notifications: Notification[] = [];

    public constructor(
        private readonly rokezzzNotificationService: RokezzzNotificationService
    ) {
        this.notifications = this.rokezzzNotificationService.getNotifications();
    }

    public closeNotification(notification: Notification): void {
        this.rokezzzNotificationService.dismissNotification(notification);
    }
}
